module.exports = __webpack_public_path__ + "img/fig04.930b6cb1.jpg";